import React from 'react';

export default function GiftcardSelection({
  availableGiftcards,
  giftcardChoice,
  selectedGiftcard,
  onChoiceChange,
  onGiftcardChange,
}) {
  const selectStyle = {
    padding: '10px 12px',
    border: 'var(--background-color) 1px solid',
    borderRadius: '4px',
    fontSize: '16px',
    transition: 'border-color 0.3s ease',
    width: '100%',
  };

  const giftcardRowStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '16px',
  };

  if (!availableGiftcards || availableGiftcards.length === 0) return null;

  return (
    <div className="giftcard-selection">
      <div className="form-group" style={giftcardRowStyle}>
        <label className="default-text-color" htmlFor="giftcard-choice">
          Heb je een Cadeaubon?
        </label>
        <select
          id="giftcard-choice"
          style={selectStyle}
          value={giftcardChoice || ''}
          onChange={onChoiceChange}
        >
          <option value="" disabled>
            Selecteer
          </option>
          <option value="Ja">Ja</option>
          <option value="Nee">Nee</option>
        </select>
      </div>
      {giftcardChoice === 'Ja' && (
        <div className="form-group" style={giftcardRowStyle}>
          <label className="default-text-color" htmlFor="selected-giftcard">
            Kies je Cadeaubon
          </label>
          <select
            id="selected-giftcard"
            style={selectStyle}
            value={selectedGiftcard || ''}
            onChange={onGiftcardChange}
          >
            <option value="" disabled>
              Selecteer een cadeaubon
            </option>
            {availableGiftcards.map((giftcard, index) => (
              <option key={index} value={giftcard}>
                {giftcard}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}


